module.exports = [{
      plugin: require('../../Kalpilli.com/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Kalpilli - Escuela Montessori","short_name":"Kalpilli","start_url":"/","background_color":"#0097B2","theme_color":"#D90368","display":"minimal-ui","icon":"src/images/kalpilli-icon.png","description":"La primera escuela Montessori en México. Educación significativa desde 1965.","lang":"es","categories":["education","montessori"],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7f0b1b422198406850748cfca62ea41a"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../Kalpilli.com/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
